<template>
  <div class="tableCom">
    <div class="tableTitle">
      <!--<span class="col-lg-1 col-md-1 col-xs-2 col-sm-1">序号</span>-->
      <span class="col-lg-4 col-md-4 col-xs-4 col-sm-4">品牌名称</span>
      <span class="col-lg-4 col-md-4 col-xs-4 col-sm-4">供应品类</span>
      <span class="col-lg-4 col-md-4 col-xs-4 col-sm-4">协议名称</span>
    </div>
    <div class="noData" v-if="nodata || searchResult || tenderLoad">
      <div class="noDataCon" v-if="nodata">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/noData.png" alt="">
        <p>暂无数据</p>
      </div>
      <div class="noDataSearch" v-else-if="searchResult">
        <h4>“{{keySearch}}”相关的搜索结果</h4>
        <p>共0个搜索结果，您可以尝试其他搜索词</p>
      </div>
      <div class="loadingBox" v-loading="tenderLoad"></div>
    </div>
    <div class="tableCon" v-show="!tenderLoad">
      <p class="tableTr clearfix" v-for="(protocol,index) in protocolList" :key="index">
        <!--<span class="col-lg-1 col-md-1 col-xs-2 col-sm-1">{{index+1}}</span>-->
        <span class="col-lg-4 col-md-4 col-xs-4 col-sm-4">{{protocol.brandName}}</span>
        <span class="col-lg-4 col-md-4 col-xs-4 col-sm-4">{{protocol.supplyCategory}}</span>
        <!-- <router-link :to='directUrl' tag='a' @click.native='jump' target='_blank'>page2</router-link> -->

        <a class="col-lg-4 col-md-4 col-xs-4 col-sm-4" @click.stop.prevent="viewProtocol(protocol.id,viewProtocolDetailUrl, protocol, index)">
          <a @click.stop.prevent="viewProtocol(protocol.id,viewProtocolDetailUrl, protocol, index)">{{protocol.protocolName}}<i class="newIcon" v-if="protocol.newFlag"></i></a>
        </a>
      </p>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import {customSearchResultClick} from '@/assets/js/sensors'
  export default {
    props: ['protocolList','viewProtocolDetailUrl','tenderLoad','keySearch','searchResult','nodata', 'currentPageDesignated'],
    data () {
      return {
        userInfo:{},
        directUrl:''
      }
    },
    created () {
      if(this.getToken('isLogin') !=''){
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      }
    },
    computed: mapState([
      'KP'
    ]),
    methods: {
      jump(){
        
        
      },
      viewProtocol(protocolId,viewProtocolDetailUrl, item, index){
        if(this.getToken('isLogin') == ''){
          this.$router.push({path:'/login',query:{redirectURL:'/protocol'}});
        }else if(this.getToken('examineStatus') == '200'){
          this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
        }else if(this.getToken('examineStatus') == '300'){
          this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
        }else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
          this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
              dangerouslyUseHTMLString: true,
              customClass:'mobileText',
              center: true,
              showClose:false
            });
        }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
          if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
            this.$alert('<p>请登录pc端完善企业信息</p>', '', {
                dangerouslyUseHTMLString: true,
                customClass:'mobileText',
                center: true,
                showClose:false
            });
          } else {
            this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
              cancelButtonClass:'cancelBtn',
              customClass:'mobileText',
              cancelButtonText: '以后再说',
              confirmButtonText: '点我补全',
              center: true
            }).then(() => {
              this.$router.push({path:'/inforPerfection'});
            }).catch(() => {
                this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
                }).then((res) => {
                  this.data = res.data;
                  this.removeCookie('TALK_LATER_'+this.data.userId);
                  this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
                });
            });
          }
        }
        else{
          this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
          this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
          this.$axios.post('/onelink.mdata.main.api/recruitInfo/checkHasViewDataAuth?userId='+this.userInfo.id+"&currentOrgId="+this.companyInfo.orgId, {
          }).then((res) => {
            this.loading=false;
            this.data = res.data;
            if(this.data){
              this.directUrl = '/recruit?redirctUtl='+viewProtocolDetailUrl + protocolId;
              if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
                this.$router.push({path:'/recruit', query: {  redirctUtl: viewProtocolDetailUrl + protocolId }})
              }else{
                let routeData = this.$router.resolve({ path: '/recruit', query: {  redirctUtl: viewProtocolDetailUrl + protocolId } });
                window.open(routeData.href, '查看协议信息');
              }
              
              // this.$router.push({path:this.directUrl});
              // let newWin = window.open("about:blank",'查看采购协议','width='+ (window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ ',top=0,left=0,resizable=yes,status=yes,menubar=no,scrollbars=yes');
              // newWin.location.href=viewProtocolDetailUrl + protocolId;
              // window.open(viewProtocolDetailUrl + protocolId,'查看协议信息','width='+ (window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ ',top=0,left=0,resizable=yes,status=yes,menubar=no,scrollbars=yes');
              // window.location.href = viewProtocolDetailUrl + protocolId;
            }else{
              this.$alert('<p>很抱歉，您没有访问权限…</p>', '', {
                dangerouslyUseHTMLString: true,
                customClass:'mobileText',
                center: true
              });
            }
          }).catch((err) => {
            console.log(err)
          })

          let position_number = (Number(this.currentPageDesignated)-1) * 10 + (index + 1)

          customSearchResultClick({
            position: "复星战略协议搜索",
            new_keyword: this.keySearch || '',
            keyword_type: '',
            position_number: position_number,
            project_name: item.protocolName,
            supplier: ''
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/protocolTable/index.vue